// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__8rKgZ","h1Title":"page_h1Title__g9xe_","tradingView":"page_tradingView__H1Igr","faq":"page_faq__0OAOY"};